export const statusLabels = {
  available: 'Available',
  checked_out: 'Checked Out',
  under_repair: 'Under Repair',
  retired: 'Retired'
};

const statusOrder = {
  checked_out: 1,
  under_repair: 2,
  available: 3,
  retired: 4
};

const normalize = (value) => String(value || '').toLowerCase().trim();

export const buildInventoryCounts = (items, inventoryController) => {
  return {
    total: items.length,
    available: items.filter((item) => item.status === 'available').length,
    checkedOut: items.filter((item) => item.status === 'checked_out').length,
    overdue: items.filter((item) => inventoryController.getDueStatus(item).isOverdue).length,
    underRepair: items.filter((item) => item.status === 'under_repair').length
  };
};

export const matchesSearch = (item, searchTerm, activeAssignment) => {
  if (!searchTerm) return true;
  const haystack = [
    item.name,
    item.reference,
    item.serialNumber,
    item.type,
    item.notes,
    activeAssignment?.assignedToName,
    activeAssignment?.assignedToType
  ]
    .filter(Boolean)
    .map((value) => normalize(value))
    .join(' ');
  return haystack.includes(normalize(searchTerm));
};

export const filterInventoryItems = ({ items, filters, inventoryController }) => {
  return items.filter((item) => {
    const activeAssignment = inventoryController.getActiveAssignment(item);
    if (!matchesSearch(item, filters.search, activeAssignment)) return false;
    if (filters.types.length && !filters.types.includes(item.type)) return false;
    if (filters.statuses.length && !filters.statuses.includes(item.status)) return false;
    if (filters.assignment === 'assigned' && !activeAssignment) return false;
    if (filters.assignment === 'unassigned' && activeAssignment) return false;
    if (filters.condition !== 'all' && normalize(item.condition) !== normalize(filters.condition)) return false;
    const dueStatus = inventoryController.getDueStatus(item);
    if (filters.due === 'overdue' && !dueStatus.isOverdue) return false;
    if (filters.due === 'dueSoon' && !dueStatus.isDueSoon) return false;
    return true;
  });
};

export const sortInventoryItems = (items, inventoryController) => {
  return [...items].sort((a, b) => {
    const aDue = inventoryController.getDueStatus(a);
    const bDue = inventoryController.getDueStatus(b);
    if (aDue.isOverdue !== bDue.isOverdue) return aDue.isOverdue ? -1 : 1;
    if (aDue.isOverdue && bDue.isOverdue) {
      return (aDue.daysRemaining || 0) - (bDue.daysRemaining || 0);
    }
    const statusDelta = (statusOrder[a.status] || 99) - (statusOrder[b.status] || 99);
    if (statusDelta !== 0) return statusDelta;
    const aDueDate = a.activeAssignment?.dueDate || '';
    const bDueDate = b.activeAssignment?.dueDate || '';
    if (aDueDate && bDueDate && aDueDate !== bDueDate) {
      return aDueDate.localeCompare(bDueDate);
    }
    return a.name.localeCompare(b.name);
  });
};
